import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'comment-form',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: `./commentForm.component.html`,
  styleUrl: './commentForm.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentFormComponent implements OnChanges {
  @Input() shopingCart: string = '';
  @Input() textHedaer: string = '';
  @Output() commentFor = new EventEmitter<{ comment: string, starts: number, shopingCart: string }>();
  commentForm: FormGroup;
  isLoading = signal(false);
  constructor(private fb: FormBuilder,

  ) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
      starts: [, Validators.required],
      shopingCart: [this.shopingCart, Validators.required],

    })
  }
  ngOnChanges(changes: SimpleChanges): void {

    if (changes['shopingCart']) {
      this.commentForm.patchValue({ shopingCart: this.shopingCart });
      // console.log('id del carrito de la compra', this.shopingCart);

    }
  }

  setRating(rating: number): void {
    this.commentForm.patchValue({ starts: rating });
  }



  get commentFormu() {
    return {
      comment: this.commentForm.get('comment')?.value,
      starts: this.commentForm.get('starts')?.value,
      shopingCart: this.commentForm.get('shopingCart')?.value,
    }
  }

  onSubmit(): void {
    if (this.commentForm.valid) {
      this.isLoading.set(true);
      this.commentFor.emit(this.commentFormu);
    }
  }

  resetLoading(): void {
    this.isLoading.set(false);
  }
}
